__turbopack_context__.v({
  "buttonLeft": "CarouselControls-module__cJAxjW__buttonLeft",
  "buttonRight": "CarouselControls-module__cJAxjW__buttonRight",
  "navigationContainer": "CarouselControls-module__cJAxjW__navigationContainer",
});
